module.exports = __webpack_public_path__ + "img/12-128.ad2f692f.png";